// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "table[data-v-4142906e]{margin-top:10px;width:100%}#bill-top[data-v-4142906e]{padding:5px;margin-inline:2%;border-bottom:2px solid #20b2aa}.error-message[data-v-4142906e]{text-align:center}#bill-bar[data-v-4142906e]{display:flex;justify-content:space-between;align-items:center}.del-bill[data-v-4142906e]{margin-left:10px;font-size:20px}", ""]);
// Exports
module.exports = exports;
